export default __webpack_public_path__ + "static/media/link-arrow.ad407870.svg";